import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LocaleProvider } from "./contexts/LocaleContext";
import { lazy, Suspense } from "react";
import { ProductLandingTemplate } from "./templates/ProductLandingTemplate";
import { downAlternativeConfig } from "./config";

// Lazy load non-critical routes for better initial page load
const LPManager = lazy(() => import('./pages/LPManager'));
const QuizPage = lazy(() => import('./pages/QuizPage'));
const AdvertorialPage = lazy(() => import('./pages/AdvertorialPage'));
const ComparePage = lazy(() => import('./pages/ComparePage'));

const LoadingSpinner = () => null;

function Router() {
  return (
    <Switch>
      {/* ============================================ */}
      {/* ADMIN - LP Manager Dashboard */}
      {/* ============================================ */}
      <Route path={"/admin"}>
        {() => <Suspense fallback={<LoadingSpinner />}><LPManager /></Suspense>}
      </Route>

      {/* ============================================ */}
      {/* QUIZ FUNNEL */}
      {/* ============================================ */}
      <Route path={"/quiz"}>
        {() => <Suspense fallback={<LoadingSpinner />}><QuizPage /></Suspense>}
      </Route>

      {/* ============================================ */}
      {/* ADVERTORIAL */}
      {/* ============================================ */}
      <Route path={"/advertorial"}>
        {() => <Suspense fallback={<LoadingSpinner />}><AdvertorialPage /></Suspense>}
      </Route>

      {/* ============================================ */}
      {/* LISTICLE / COMPARE */}
      {/* ============================================ */}
      <Route path={"/compare"}>
        {() => <Suspense fallback={<LoadingSpinner />}><ComparePage /></Suspense>}
      </Route>

      {/* ============================================ */}
      {/* HOMEPAGE (PDP) */}
      {/* ============================================ */}
      <Route path={"/"}>
        {() => <ProductLandingTemplate config={downAlternativeConfig} />}
      </Route>

      {/* ============================================ */}
      {/* 404 */}
      {/* ============================================ */}
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
      >
        <LocaleProvider>
          <TooltipProvider>
            <Toaster />
            <Router />
          </TooltipProvider>
        </LocaleProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
